export default "__VITE_ASSET__BSUEh1DS__"